import * as React from 'react';
import { FileCheck2 } from 'lucide-react';

export const PageTitle = () => (
  <div className="flex items-center gap-2 font-GilroySemibold">
    <FileCheck2 className="h-5 w-5" />
    <h1 className="text-md">
      <span className="font-GilroySemibold">Controle</span>
      <span className="ml-2 font-GilroyRegular uppercase">Comprovantes</span>
    </h1>
  </div>
);
